var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard"},[_c('ResponsiveContent',[_vm._v("\n    Display the following cards:\n\n    Recent job applications, My questions, my CVs, pinned idea boards, learning paths, my interests\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }